import PageLayout from '../components/layout/PageLayout';
import Seo from '../components/Seo';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <PageLayout title="Страница не найдена">
      <Seo
        title="Страница не найдена — Recvisit"
        description="Запрошенная страница не найдена."
        canonicalPath="/404"
      />
      <div className="container">
        <div className="nf">
          <div className="nf-code">404</div>
          <div className="nf-text">
            Похоже, вы перешли по неверной ссылке или страница была перемещена.
          </div>
          <div className="nf-actions">
            <a className="nf-btn nf-btn-primary" href="/">На главную</a>
            <a className="nf-btn" href="/faq">FAQ</a>
            <a className="nf-btn" href="/system-requirements">Системные требования</a>
            <a className="nf-btn" href="/contacts">Контакты</a>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}

